
import React, { useState } from "react";
import "./CorporatePageElementsCss/BulkDownload.css";

const CorporateSelectedDownloadModal = ({
  totalReports = 0,

  onClose,
  fromDate,
  toDate,
  onProceed,
  progress,
  isDownloading,
}) => {
  const [withHeader, setWithHeader] = useState(true);
  const dateRangeText =
    fromDate && toDate ? `from ${fromDate} to ${toDate}` : "";

  return (
    <div className="bulk-modal-overlay">
      <div className="bulk-modal-container">
        <button className="close-btn" onClick={onClose}>
          ✕
        </button>

        <h2 className="bulk-title">Download Selected  Report(s)</h2>

        <p className="found-text">
          Found <span>{totalReports}</span> reports {dateRangeText}
        </p>

        <div className="option-card" onClick={() => setWithHeader(true)}>
          <div className={`radio-circle ${withHeader ? "active" : ""}`} />
          <span>Report(s) With Header</span>
        </div>

        <div className="option-card" onClick={() => setWithHeader(false)}>
          <div className={`radio-circle ${!withHeader ? "active" : ""}`} />
          <span>Report(s) Without Header</span>
        </div>

        <p className="note-text">
          <b>Note:</b> The report download process has begun. All above reports
          will be merged into a single PDF. Please note that the download &
          merge process may take longer than usual. Thank you for your patience.
        </p>

        <button className="proceed-btn" onClick={() => onProceed(withHeader)()}>
          Proceed to Download
        </button>
        <div className="progress-area">
          {isDownloading && (
            <>
              <p style={{ textAlign: "center", marginTop: "8px" }}>
                Downloading... {progress}%
              </p>
              <div className="progress-bar-container">
                <div
                  className="progress-bar"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CorporateSelectedDownloadModal;
